import React from "react";
import Icon from "./Icon";

const EditSvg = () => <Icon name="edit" className=" h-4 w-4" strokeWidth="2" />;

export default EditSvg;
